/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable @typescript-eslint/explicit-function-return-type */
import { Component, OnInit, ViewChild, ViewEncapsulation } from "@angular/core";
import { FormBuilder, FormGroup, NgForm, Validators } from "@angular/forms";
import { MatSnackBar } from "@angular/material/snack-bar";
import { Router } from "@angular/router";
import { FetchData, UserAccountMessages } from "app/shared/generalMethods";
import { GetSalesforceDataService } from "app/services/salesforce-data";
import { AdminProgramService } from "app/services/admin-program.service";
import { database } from "firebase-admin";

@Component({
  selector: "admin-membership-form",
  templateUrl: "./admin-membership-form.component.html",
  styleUrls: ["./admin-membership-form.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class AdminMembershipFormComponent implements OnInit {
  @ViewChild("adminFormNgForm") adminFormNgForm: NgForm;
  adminForm: FormGroup;
  pageLoader: boolean = false;
  pageLoaderText: string;
  userRecord: any;
  dataSet: [];
  roleOptions: { key: string; value: string }[] = [];
  adminEmailFirebase = "";
  adminUserName: string = "";
  adminPhoneNumber: string = "";

  constructor(
    private _fetchData: FetchData,
    private _formBuilder: FormBuilder,
    private adminProgramService: AdminProgramService,
    private _snackBar: MatSnackBar,
    public router: Router
  ) {
    this.userRecord = this._fetchData.data;
  }

  ngOnInit(): void {
    const user = JSON.parse(localStorage.getItem("user"));
    this.adminEmailFirebase = user ? user.email : "";
    this.adminUserName = user ? user.displayName : "";

    this.setAdminPhoneNumber();
    this.renderForm();

    if (this._fetchData.data?.lstRolePicklist) {
      this.roleOptions = this._fetchData.data.lstRolePicklist;
    } else {
      this.roleOptions = [{ key: "Admin", value: "Administrator" }];
    }

    this.tryAutoSubmitIfComplete();
  }

  private tryAutoSubmitIfComplete(): void {
    const formValue = this.adminForm.value;

    const hasRequiredData =
      formValue.name?.trim() &&
      formValue.email?.trim() &&
      formValue.cellPhone?.trim() &&
      formValue.role?.trim();

    if (hasRequiredData) {
      this.onFormSubmit();
    }
  }

  private setAdminPhoneNumber(): void {
    const storedUID = localStorage.getItem("UID");
    const organizations = this._fetchData.data?.lstOrganizations || [];
    const matchedOrg = organizations.find(
      (org: any) => org.UID__c === storedUID
    );
    this.adminPhoneNumber = matchedOrg ? matchedOrg.Phone_Number__c : "";
  }

  renderForm(): void {
    this.adminForm = this._formBuilder.group({
      name: [this.adminUserName, [Validators.required]],
      email: [this.adminEmailFirebase, [Validators.required, Validators.email]],
      address: [""],
      city: [""],
      cellPhone: [this.adminPhoneNumber, [Validators.required]],
      role: ["Admin", [Validators.required]],
      isActive: [true],
    });
  }

  onInputNumeric(event: any): void {
    const pattern = /[0-9]/;
    const inputChar = String.fromCharCode(event.charCode);

    if (!pattern.test(inputChar)) {
      event.preventDefault();
    }
  }

  onFormSubmit(): void {
    if (this.adminForm.valid) {
      this.pageLoader = true;
      this.pageLoaderText = "Creating administrator...";
      const formData = this.prepareAdministratorData();
      const uID = localStorage.getItem("UID");

      if (!uID) {
        this.openSnackBar("User ID not found. Please login again.");
        this.pageLoader = false;
        return;
      }

      this.adminProgramService.addAdministrator(formData, uID).subscribe({
        next: (response: any) => {
          if (response.success) {
            this.openSnackBar(
              response.message || "Administrator added successfully!"
            );

            const adminIdentifier = response.adminId || response.uid || uID;
            if (adminIdentifier) {
              this.adminProgramService
                .getAdminByUID(adminIdentifier)
                .subscribe({
                  next: (adminData) => {
                    if (adminData) {
                      this._fetchData.setLocalStorage(adminData.msg);
                      const dataRaw = localStorage.getItem("DataSet");

                      if (dataRaw) {
                        const data = JSON.parse(dataRaw);
                        localStorage.setItem(
                          "adminId",
                          data.data.lstAdministratorData[0].Id
                        );
                      } else {
                        console.error("No DataSet found in localStorage.");
                      }
                      const identifier = adminData?.id || adminIdentifier;
                      this.router.navigate(["/profile-detail"]);
                    } else {
                      this.router.navigate(["/profile-dashboard"]);
                    }
                  },
                  error: (err) => {
                    this.router.navigate(["/profile-dashboard"]);
                  },
                });
            } else {
              this.router.navigate(["/profile-dashboard"]);
            }
          } else {
            this.openSnackBar(
              response.error || "Failed to create administrator"
            );
          }
          this.pageLoader = false;
        },
        error: (err) => {
          this.openSnackBar(err.message || "Failed to connect to server");
          this.pageLoader = false;
        },
      });
    } else {
      this.openSnackBar("Please fill in all required fields correctly.");
      this.markFormGroupTouched(this.adminForm);
    }
  }

  prepareAdministratorData(): any {
    const formValue = this.adminForm.value;
    const organizations = this._fetchData.data?.lstOrganizations || [];
    const matchedOrg = organizations.find(
      (org: any) =>
        org.Email_Address__c?.toLowerCase() === formValue.email?.toLowerCase()
    );

    const organizationId = matchedOrg ? matchedOrg.Id : null;

    return {
      Administrator_Name__c: formValue.name,
      Email__c: formValue.email,
      Address__c: formValue.address,
      Town_City__c: formValue.city,
      Phone__c: formValue.cellPhone,
      Role__c: formValue.role,
      Is_Active__c: formValue.isActive,
      UID__c: formValue.uid,
      Organization__c: organizationId,
    };
  }

  openSnackBar(message: string): void {
    this._snackBar.open(message, "Close", {
      duration: 6000,
      horizontalPosition: "center",
      verticalPosition: "top",
    });
  }

  markFormGroupTouched(formGroup: FormGroup): void {
    Object.values(formGroup.controls).forEach((control) => {
      control.markAsTouched();
      if (control instanceof FormGroup) {
        this.markFormGroupTouched(control);
      }
    });
  }
}
